import Stars from 'atomic/stars';
import classNames from 'classnames';
import flectionNumeral from 'helpers/number';
import OpinionsInterface from 'interfaces/opinions.interface';
import React, { ReactNode, createElement } from 'react';
import Link from 'atomic/link';
import { generateAddOpinionLink } from 'helpers/url-manager';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './rating.scss';

interface OpinionsProps {
    className?: string;
    size?: 'sm' | 'md' | 'lg';
    opinions: Pick<OpinionsInterface, 'average' | 'count' | 'url'> | null;
    isAddOpinion?: boolean;
}

const Rating: React.FC<OpinionsProps> = ({
    opinions,
    className,
    size = 'md',
    isAddOpinion = false
}) => {
    const renderRatingCount = (): ReactNode => {
        if (!opinions) {
            return null;
        }

        if (!opinions.count && isAddOpinion && opinions.url) {
            return (
                <Link
                    href={generateAddOpinionLink(opinions.url)}
                    className="rating__add-opinion"
                    target={LinkTarget.BLANK}
                    rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                >
                    Dodaj opinie
                </Link>
            );
        }

        if (opinions.count) {
            return (
                createElement(opinions.url ? 'a' : 'span', {
                    className: 'rating-count brackets',
                    href: opinions.url || void 0,
                    rel: opinions.url ? SeoLinkRelEnum.NOOPENER_NOREFERRER : void 0,
                    target: opinions.url ? LinkTarget.BLANK : void 0
                }, (
                    flectionNumeral(opinions.count, ['opinia', 'opinie', 'opinii'])
                ))
            );
        }

        return (
            <span className="rating-count">Brak opinii</span>
        );
    };

    return (
        opinions && (
            <div
                className={classNames({
                    rating: true,
                    [String(className)]: Boolean(className)
                })}
            >
                <Stars
                    className="rating-stars"
                    width={opinions.average}
                    inline={true}
                    size={size}
                />
                {opinions.average > 0 && (
                    <span className="rating-average">
                        {opinions.average.toFixed(1).replace('.', ',')}
                    </span>
                )}
                {renderRatingCount()}
            </div>
        )
    );
};

export default Rating;
